@if (mediaQueryService.breakpoints$ | async; as breakpoints) {
  @if (!(editMode$ | async)) {
    <div class="locations-edit-container" data-test-id="locations-edit-container">
      <div class="locations-edit-content">
        @if (!insideSidePanel) {
          <div class="subtitle">Locations</div>
        }
        @if (atLeastOneChecked) {
          <checkboxes-categories-details [checkboxes]="locations"></checkboxes-categories-details>
        }
        @if (!readonly && !insideSidePanel && canEdit) {
          @if (locationsCheckedLength() === 0) {
            <button (click)="edit()" class="small-button" data-test-id="locations-edit-add-button" mat-button>
              Add
            </button>
          }
          @if (atLeastOneChecked) {
            <button (click)="edit()" class="small-button" data-test-id="locations-edit-edit-button" mat-button>
              Edit
            </button>
          }
        }
      </div>
    </div>
  } @else {
    <form
      [formGroup]="locationEditForm"
      [ngClass]="{ loading: loading }"
      (keydown)="keyListener($event)"
      (keypress)="keyListener($event)"
      (ngSubmit)="save(locationEditForm)"
      class="edit-form"
      data-test-id="locations-edit-form"
      name="locationEditForm"
      novalidate
    >
      <h4 class="font-bold">Edit Preferred work location(s)</h4>
      <div class="location-options">
        <div>
          <checkboxes-categories-edit
            [checkboxes]="locations"
            [name]="'locations'"
            [parent]="locationEditForm.controls['checkboxes']"
          ></checkboxes-categories-edit>
        </div>
        <div>
          <mat-error
            [field]="locationEditForm.controls['checkboxes']"
            [form]="locationEditForm"
            [messages]="['noRequiredCheckboxCount']"
            [texts]="{ noRequiredCheckboxCount: 'Select minimum one location' }"
            data-test-id="locations-edit-matError"
          ></mat-error>
          @if (error) {
            <span class="color-danger" data-test-id="locations-edit-serverError">
              Something went wrong - please try again later.
            </span>
          }
        </div>
      </div>
      <div class="form-actions">
        <button
          [loading]="loading"
          class="small-button"
          color="primary"
          data-test-id="locations-edit-save-button"
          mat-stroked-button
          type="submit"
        >
          {{ breakpoints.ltMd ? COMMON_BUTTONS_TEXTS.SAVE_CHANGES_MOBILE : COMMON_BUTTONS_TEXTS.SAVE_CHANGES_DESKTOP }}
        </button>
        <button
          (click)="reset()"
          class="small-button cancel-button"
          color="primary"
          data-test-id="locations-edit-discard-button"
          mat-button
        >
          {{
            breakpoints.ltMd
              ? COMMON_BUTTONS_TEXTS.DISCARD_CHANGES_MOBILE
              : COMMON_BUTTONS_TEXTS.DISCARD_CHANGES_DESKTOP
          }}
        </button>
      </div>
    </form>
  }
}
